module.exports = __webpack_public_path__ + "static/media/YF04_4.71fd2e5c.jpg";